window.swal = window.swal || function swal(options) {
  const message = typeof options === "string" ? options : options?.text || options?.title || "";
  return Promise.resolve(window.alert(message));
};

export default window.swal;
